module.exports = __webpack_public_path__ + "static/media/pinamar.04fe9945.webp";